'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactCustomScrollbars = require('react-custom-scrollbars');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LicenseInfoDialog = function (_React$Component) {
  (0, _inherits3.default)(LicenseInfoDialog, _React$Component);

  function LicenseInfoDialog() {
    (0, _classCallCheck3.default)(this, LicenseInfoDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LicenseInfoDialog.__proto__ || (0, _getPrototypeOf2.default)(LicenseInfoDialog)).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(LicenseInfoDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {}
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.onCloseNo();
    }
  }, {
    key: 'render',
    value: function render() {
      var licenses = require('data/licenses/licenses.json');
      var styles = require('./LicenseInfoDialog.scss');

      var renderThumbVertical = function renderThumbVertical() {
        return _react2.default.createElement('div', { style: {
            background: '#A9A9A9',
            width: '8px',
            display: 'block'
          } });
      };

      var renderTrackVertical = function renderTrackVertical(props) {
        return _react2.default.createElement('div', (0, _extends3.default)({}, props, { style: {
            right: 2,
            bottom: 2,
            top: 2,
            borderRadius: 0,
            position: 'absolute',
            width: 8,
            cursor: 'pointer',
            background: '#0F0F0F'
          } }));
      };

      var license = licenses[this.props.type];

      return _react2.default.createElement(
        _components.PopupBox,
        null,
        _react2.default.createElement(
          'div',
          { className: styles.LicenseInfo__Container },
          _react2.default.createElement(
            _reactCustomScrollbars.Scrollbars,
            { universal: true, renderThumbVertical: renderThumbVertical, renderTrackVertical: renderTrackVertical },
            _react2.default.createElement(
              'div',
              { className: styles['LicenseInfo__Container-inner'] },
              _react2.default.createElement(
                'h1',
                null,
                license.title
              ),
              license.p.map(function (p) {
                return _react2.default.createElement(
                  'p',
                  null,
                  p
                );
              }),
              _react2.default.createElement(
                'ul',
                null,
                license.li.map(function (l) {
                  return _react2.default.createElement(
                    'li',
                    null,
                    l
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return LicenseInfoDialog;
}(_react2.default.Component);

exports.default = LicenseInfoDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LicenseInfoDialog/LicenseInfoDialog.jsx
// module id = 2716
// module chunks = 0